// extracted by mini-css-extract-plugin
export var pillWrapper = "_mk-0";
export var showOverflow = "_mk-1";